<template>
  <MDBCard v-if="context.canSeePointsBox" class="mb-3 mb-lg-0 points-container" :class="[
    {
      intro__step: user?.intro == 3,
      'points-container--stretch': stretch,
    },
  ]">
    <MDBCardBody>
      <template v-if="user?.points?.vesting === true">
        <MDBCardTitle class="title text-uppercase font-12 font-md-25">
          {{ $t("points.dashboard.dashboardBox.title") }}
        </MDBCardTitle>
        <MDBCardText>
          <p class="mb-0 font-xxxl-18 font-11 fw-bold">
            {{ $t("points.dashboard.dashboardBox.availPoints") }}
          </p>
          <h2 class="success-green font-18 font-md-25 fw-bold">
            {{ user.points && user.points.avail_points ? $filters.formatNumberWithCommas(user.points.avail_points) : 0
            }} {{ $t("points.dashboard.dashboardBox.points") }}
          </h2>
          <p class="mb-0 font-xxxl-18 font-11 fw-bold">
            {{ $t("points.dashboard.dashboardBox.awaitingPoints") }}
          </p>
          <h2 class="text-orange font-18 font-md-25 fw-bold">
            {{ user.points && user.points.awaiting_points ? $filters.formatNumberWithCommas(user.points.awaiting_points)
              : 0 }} {{ $t("points.dashboard.dashboardBox.points") }}
          </h2>
          <DashboardLink :to="{ name: pointsBoardRouteName }" :disabled="(user?.intro == 2) ||
            isStaff ||
            !context.canSeePointsInfo
            ">
            {{ $t("points.dashboard.dashboardBox.button") }}
          </DashboardLink>
        </MDBCardText>
      </template>
      <template v-else>
        <MDBCardTitle class="title text-uppercase font-12 font-md-25" :class="titleClassName">
          {{ $t("bankstatement.score") }}
        </MDBCardTitle>
        <MDBCardText>
          <p class="mb-0 font-xxxl-18 font-11 fw-bold">
            {{ $t("dashboard.bankstatement.yourScore") }}
          </p>
          <h2 class="success-green font-18 font-md-25 fw-bold">
            {{ user?.display_points ? user?.points?.avail_points ?? 0 : 0 }} {{ $t("bankstatement.points") }}
          </h2>
          <p class="text-small">
            {{ $t("dashboard.bankstatement.lastUpdate") }}
            {{
              lastUpdate?.date
                ? dates.parseDate(lastUpdate?.date)
                : dates.parseDate(new Date())
            }}
          </p>
          <DashboardLink :to="{ name: 'pointsOverview' }" :disabled="isStaff ||
            !context.canSeePointsInfo
            ">
            {{ $t("dashboard.bankstatement.link") }}
          </DashboardLink>
        </MDBCardText>
      </template>
    </MDBCardBody>
  </MDBCard>
</template>

<script setup>
import {
  MDBCard,
  MDBCardBody,
  MDBCardTitle,
  MDBCardText,
} from "mdb-vue-ui-kit";
import { useStore } from "vuex";
import DashboardLink from "@/components/Dashboard/Dashboard-link.vue";
import { ref, watch, computed, defineProps } from "vue";
import dates from "@/plugins/dates";
import { useItemsConditions } from '@/composables/useItemsConditions'
import { DASHBOARD_SETTINGS } from "@/config";
import { extractCountryCode } from "@/utils/tenantUtils";

defineProps({
  stretch: {
    type: Boolean,
    default: false,
  },
});

const store = useStore();

const user = computed(() => store.getters.getMe);
const pointsBoardRouteName = computed(() =>
  DASHBOARD_SETTINGS.usesNewKpiDashboard(extractCountryCode(window.location.href))
    ? "wholesaler"
    : "promotions"
);

const titleClassName = 'de-AT' === store.getters.getCurrentLocale ? '' : 'title-slash'
// Destructure specific context access flags from useItemsConditions
// This provides direct access to individual permission checks
// such as feature toggles or tenant-based availability (e.g. my-bs-app)
const { getContext } = useItemsConditions()
const context = computed(() => getContext())

const isStaff = ref(false);
watch(user, (newVal) => {
  if (newVal && newVal.roles.find((item) => item.name === "staff")) {
    isStaff.value = true;
  }
})

const lastUpdate = computed(() => store.getters.getLastBankStatement);

</script>

<style lang="scss" scoped>
@import "@/styles/_variables.scss";

.points-container {
  min-height: $dashboardCardHeight;
}

.points-container--stretch {
  width: 100%;
  box-sizing: border-box;
  flex: 1 1 auto;
  align-self: stretch;
}

:deep(.card-body) {
  height: 100%;
}
</style>
